module.exports = __webpack_public_path__ + "img/shop_default.ce455b1e.svg";